import React, { useState } from "react";
import { AppListing } from "../../../../components/appListing";
import { useScreeningPreviewMutation } from "../../../../redux/service/careplan_service";
import moment from "moment";
import { IoMdEye } from "react-icons/io";
import MainPageDialog from "../../../../components/mainPageDialog";

const CareplanScreening = ({ listData = [], loading = false }) => {
  const [screeningPreview] = useScreeningPreviewMutation();
  const [screeningPreviewDialog, setScreeningPreviewDialog] = useState(false);
  const [screeningPreviewData, setScreeningPreviewData] = useState([]);

  const handleScreening = (item) => {
    setScreeningPreviewDialog(true);
    setScreeningPreviewData(item);
  };

  const screeningCols = [
    {
      title: "Form Title",
      key: "form_title",
      getData: (data) => {
        const originalDate =
          data?.created !== "" ? moment(data?.created).format("l") : "";
        return `${data?.form_title} ${originalDate}`;
      },
    },
    {
      title: "Screening Form",
      key: "form_title",
    },
    {
      title: "Specialty",
      key: "specialities",
      getData: (item) => {
        return (
          <ul className="list-disc flex flex-col">
            {item?.specialities?.length > 0 && Array.isArray(item?.specialities)
              ? item?.specialities?.map((v) => <li>{v?.title}</li>)
              : "Specialities Not Attached"}
          </ul>
        );
      },
    },
    {
      title: "Shared",
      key: "",
      getData: (item) => (
        <div className="flex w-[100%] items-start justify-start px-2 ">
          {
            <span>
              {item?.emailed === 1
                ? "Emailed"
                : item?.emailed === 2
                ? "Submitted"
                : "_"}
            </span>
          }
        </div>
      ),
    },
    {
      title: "Created By",
      key: "created_by_name",
    },
    {
      title: "Last Modified",
      key: "modified",
      getData: (data) => {
        const originalDate =
          data?.modified !== "" ? moment(data?.modified).format("l") : "";
        return `${originalDate}`;
      },
    },
    {
      title: "Preview",
      key: "preview",
      colClass: "col-md-1 text-center",
      getData: (item) => (
        <button
          onClick={() => handleScreening(item)}
          className="flex w-[100%] items-start justify-start px-2 text-blue-500 cursor-pointer hover:underline"
        >
          <IoMdEye />
        </button>
      ),
    },
    {
      title: "Follow Up",
      key: "",
      colClass: "col-md-1 text-center",
      getData: (item) => (
        <div className="flex w-[100%] items-start justify-start px-2">
          {item?.follow_up === 1 && <span>Follow Up</span>}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="py-2">
        <AppListing
          loading={loading}
          listData={listData}
          cols={screeningCols}
        />
      </div>
      {screeningPreviewDialog && (
        <MainPageDialog
          title={screeningPreviewData?.form_title}
          modalSize="lg"
          maxHeight={true}
          footerList={[
            {
              title: "Cancel",
              type: "cancel",
              action: () => setScreeningPreviewDialog(false),
            },
          ]}
          onCancelHandler={() => setScreeningPreviewDialog(false)}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: screeningPreviewData?.form_preview,
            }}
          />
          {screeningPreviewData?.form_preview === "" && "No Preview available"}
        </MainPageDialog>
      )}
    </>
  );
};

export default CareplanScreening;
